import { ApiError } from '@/api/errors';
import { LiveMessageType } from '@/domain/live';

/** Live feed types that mean the match left the live catalog (legacy finish/result). */
export function isLiveFinishMessageType(tp: number | undefined): boolean {
  return tp === LiveMessageType.LiveUpdateFinish || tp === LiveMessageType.Result;
}

/** Live details GET returned 404 — event is no longer on the live feed. */
export function isLiveEventNotFoundError(error: unknown): boolean {
  return error instanceof ApiError && error.status === 404;
}
